import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@material-ui/core";

const labelId = "confirm-change-contact-source-dialog";

const ConfirmChangeContactSourceDialog: React.FC<{
  open: boolean;
  onClose: () => any;
  onConfirm: () => any;
}> = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog open={open} onClose={onClose} aria-labelledby={labelId}>
      <DialogTitle id={labelId}>Confirm new contact source</DialogTitle>
      <DialogContent>
        Are you sure? This will overwrite any existing contacts.
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary">
          Close
        </Button>
        <Button onClick={onConfirm} variant="contained">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmChangeContactSourceDialog;
